@if (swiperProducts().products.length) {
<h2 class="title">
  {{ getProductCarouselTitle() }}
</h2>
@if (swiperProducts().listStyle === 'carousel') {
<div class="product-list" [class]="productCarouselCss()">
  <swiper [config]="swiperProducts().swiperConfig">
    @for (sku of swiperProducts().products; track sku) {
    <ng-template swiperSlide>
      <div [ngClass]="swiperProducts().contentlet.listItemCssClass" class="dotcms-swiper">
        @if (swiperProducts().contentlet) {
        <custom-dot-cms-product-item
          ishProductContext
          [sku]="sku"
          [configuration]="swiperProducts().displayProperties"
          [displayType]="swiperProducts().listItemStyle"
          [layout]="swiperProducts().contentlet.layout"
        />
        }
      </div>
    </ng-template>
    }
  </swiper>
</div>
} @else {
<div class="product-list row">
  @for (sku of swiperProducts().products; track sku) {
  <div class="product-list-item" [ngClass]="swiperProducts().contentlet.listItemCssClass">
    <custom-dot-cms-product-item
      ishProductContext
      [sku]="sku"
      [configuration]="swiperProducts().displayProperties"
      [displayType]="swiperProducts().listItemStyle"
    />
  </div>
  }
</div>
} }
